import { observable, action, runInAction } from 'mobx'
import BaseStore from '@store/table'
import { message } from 'hljd'
import Api from '@api/li_shu/activityApi'

class Store extends BaseStore {
  @observable tab = '1'
  @observable activityList = []
  // 商家套餐列表
  @observable data = []
  // 活动位信息
  @observable info = {}
  @observable activity_position = {}
  // 已提交套餐
  @observable set_meal = []
  @observable rows = []
  @observable isSelected = false

  @observable
  pagination = {
    //分页信息
    showQuickJumper: true,
    showTotal: total => `共 ${total} 条`,
    showSizeChanger: true,
    current: 1,
    pageSize: 20,
    total: 0
  }
  @observable can_show_tip = {}

  //活动价错误
  price_error = false

  @action
  paging = ({ current }) => {
    this.pagination.current = current
    this.getList(current)
  }
  // 套餐列表
  @action
  getList = async (page = this.pagination.current) => {
    this.loading = true
    const params = {
      page: page,
      per_page: this.pagination.pageSize,
      commodity_type: '0',
      is_sold_out: '0',
      status: '1'
    }
    const {
      data: { list, total_count }
    } = await Api.getCaseListApi(params)
    runInAction('list', () => {
      this.data = list || []
      this.pagination.total = +total_count
      this.data.forEach(item => {
        if (
          this.set_meal.some(({ set_meal_id }) => {
            return set_meal_id == item.id
          })
        ) {
          item.sale_price = this.set_meal.filter(
            ({ set_meal_id }) => set_meal_id == item.id
          )[0].sale_price
        } else {
          item.sale_price = ''
        }

        runInAction(() => {
          this.$selectedRowKeys = []
          this.isSelected = false
        })
      })
      this.loading = false
    })
  }
  // 活动位信息
  @action
  getPositionInfoApi = async (id, positionId) => {
    let params = {
      marketing_activity_id: id,
      marketing_activity_position_id: positionId
    }
    let { data, success } = await Api.getPositionInfoApi(params)
    this.isLoading = true
    if (success) {
      if (data) {
        runInAction(() => {
          this.info = data
          this.activity_position = data.activity_position[0]
          this.set_meal = data.activity_position[0].set_meal
          this.isLoading = false
          this.getList()
        })
      }
    }
  }

  // 提交套餐
  @action
  submitCase = async () => {
    const { id, positionId } = this
    let meal_info = []
    let rows = this.data.filter(item => {
      return this.$selectedRowKeys.includes(item.id)
    })
    if (!rows.length) {
      return message.warning('请先选择套餐')
    }
    rows.map(({ id, sale_price }) => {
      return meal_info.push({ meal_id: id, sale_price: +sale_price || null })
    })
    let params = {
      marketing_activity_id: id,
      marketing_activity_position_id: positionId,
      meal_info: meal_info
    }

    if (this.price_error) {
      return message.error(
        `活动价格最少需下调${+this.activity_position.min_price}元`
      )
    }
    let { data, success } = await Api.submitActivityMeal(params)
    this.isLoading = true
    if (success) {
      if (data) {
        runInAction(() => {
          window.location.href = `#/localMerchant/activityRegister/activityDetail/${id}`
        })
      }
    }
  }

  @action
  goBack = () => {
    const { id } = this
    this.isSelected = false
    window.location.href = `#/localMerchant/activityRegister/activityDetail/${id}`
  }

  // 列表复选框
  @action
  $onSelectChange = (keys, rows) => {
    //DEV-11419
    if (
      (this.isSelected && this.$selectedRowKeys.length < keys.length) ||
      this.activity_position.max_set_meal_num <= this.set_meal.length
    ) {
      //修改提示
      return message.warning(
        `最多只能选择${this.activity_position.max_set_meal_num}个套餐哦！`,
        0.8
      )
    }
    this.$selectedRowKeys = keys
    this.rows = rows
    this.isSelected =
      this.$selectedRowKeys.length >
      this.activity_position.max_set_meal_num - this.set_meal.length - 1
        ? true
        : false
  }

  @action
  changeFiled = (index, record) => e => {
    clearTimeout(this.timeout)
    runInAction(() => {
      this.can_show_tip = Object.assign({}, this.can_show_tip, {
        [index]: true
      })
    })
    this.data[index] = Object.assign({}, this.data[index], {
      sale_price: e.target.value
    })
    const { sale_price } = this.data[index]
    const min_price =
      this.info.activity_position[0].min_price &&
      +this.info.activity_position[0].min_price
    const actual_price = +record.actual_price
    const hasError =
      min_price &&
      sale_price &&
      +min_price - (actual_price - sale_price) > 0 &&
      min_price < actual_price
    runInAction(() => {
      this.price_error = !!hasError
    })
    this.timeout = setTimeout(() => {
      runInAction(() => {
        this.can_show_tip = Object.assign({}, this.can_show_tip, {
          [index]: false
        })
      })
    }, 2300)
  }
}
export default new Store()
